"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var analytics_1 = require("@dynamynd/analytics");

var components_lib_1 = require("@dynamynd/components-lib");

var content_parser_1 = require("@dynamynd/content-parser");

var responsive_1 = require("@dynamynd/responsive");

var utilities_1 = require("@dynamynd/utilities");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var react_redux_1 = require("react-redux");

var redux_1 = require("redux");

var styled_components_1 = __importDefault(require("styled-components"));

var moduleSectionLayoutType_enum_1 = require("../../enums/moduleSectionLayoutType.enum");

var store_1 = require("../../store");

var index_1 = require("../index");

var styled_1 = require("../styled");

var randomTo3 = function randomTo3() {
  return utilities_1.randomNumber(1, 3);
};

var ModuleSection =
/** @class */
function (_super) {
  __extends(ModuleSection, _super);

  function ModuleSection() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.patchBackgroundUris = {
      ff: components_lib_1.appConfig.shapes.swiperFf,
      ft: components_lib_1.appConfig.shapes.swiperFt,
      qs: components_lib_1.appConfig.shapes.swiperQs,
      im: components_lib_1.appConfig.shapes.swiperIm
    };
    _this.sectionNamesMap = {
      ff: analytics_1.SectionNameEnum.factFinder,
      ft: analytics_1.SectionNameEnum.followThru,
      qs: analytics_1.SectionNameEnum.quickStart,
      im: analytics_1.SectionNameEnum.implementor
    };
    _this.tipsRotationAngles = [-6, 3, -5, 4];
    _this.mascotPositionsConfig = {
      1: [{
        top: '-34%',
        bottom: 0,
        left: '-8%',
        rotate: '-28deg'
      }, {
        top: '-66%',
        bottom: 0,
        left: '-8%',
        rotate: '-42deg'
      }],
      2: [{
        top: '-34%',
        bottom: 0,
        left: '82%',
        rotate: '28deg'
      }, {
        top: '-74%',
        bottom: 0,
        left: '-18%',
        rotate: '-42deg'
      }],
      3: [{
        top: '-34%',
        bottom: 0,
        left: '86%',
        rotate: '28deg'
      }, {
        top: '-74%',
        bottom: 0,
        left: '-14%',
        rotate: '-42deg'
      }],
      4: [{
        top: '-34%',
        bottom: 0,
        left: '86%',
        rotate: '28deg'
      }, {
        top: '-74%',
        bottom: 0,
        left: '-14%',
        rotate: '-42deg'
      }]
    };
    _this.mascotConfigPositionSmallBreakpoint = {
      1: {
        top: 'auto',
        bottom: '60%',
        left: '70%',
        rotate: '40deg'
      },
      2: {
        top: 'auto',
        bottom: '20%',
        left: '70%',
        rotate: '40deg'
      }
    };
    _this.interactiveImageInfoText = 'What about people different than me?';
    _this.minTipsToRenderSwiperOnLargeScreens = 5;

    _this.renderTips = function () {
      var _a = _this.props,
          activeBreakpoint = _a.activeBreakpoint,
          sectionName = _a.sectionName,
          tips = _a.moduleData.tips;
      if (!tips) return null;

      var _b = _this.setTipsContainerComponent(),
          TipsContainerComponent = _b.TipsContainerComponent,
          props = _b.props;

      return react_1.default.createElement(react_1.default.Fragment, null, _this.shouldRenderScrollPatch() && react_1.default.createElement(styled_1.RectangleSwiperBackground, {
        source: {
          uri: _this.patchBackgroundUris[sectionName]
        },
        smallOrMedium: responsive_1.isSmallOrMedium(activeBreakpoint),
        large: responsive_1.isLarge(activeBreakpoint)
      }), react_1.default.createElement(TipsContainerComponent, __assign({}, props), _this.renderTipsItems()));
    };

    _this.swiperControlsPressHandler = function () {
      var _a = _this.props,
          sectionName = _a.sectionName,
          moduleName = _a.moduleName,
          withCustomAnalytics = _a.withCustomAnalytics;

      if (withCustomAnalytics) {
        _this.props.tipsAndTricksInteraction({
          moduleId: moduleName,
          sectionId: _this.sectionNamesMap[sectionName]
        });
      }
    };

    _this.shouldRenderScrollPatch = function () {
      var _a = _this.props,
          activeBreakpoint = _a.activeBreakpoint,
          numberOfTipsToRender = _a.numberOfTipsToRender;
      var smallOrMedium = responsive_1.isSmallOrMedium(activeBreakpoint);

      var renderAllTips = _this.shouldRenderAllTips();

      return renderAllTips || smallOrMedium || numberOfTipsToRender >= _this.minTipsToRenderSwiperOnLargeScreens;
    };

    _this.setTipsContainerComponent = function () {
      var _a = _this.props,
          activeBreakpoint = _a.activeBreakpoint,
          numberOfTipsToRender = _a.numberOfTipsToRender;
      var medium = responsive_1.isMedium(activeBreakpoint);
      var large = responsive_1.isLarge(activeBreakpoint);
      var extraLarge = responsive_1.isExtraLarge(activeBreakpoint);

      var renderAllTips = _this.shouldRenderAllTips();

      if (!renderAllTips && numberOfTipsToRender <= _this.minTipsToRenderSwiperOnLargeScreens && (large || extraLarge)) {
        return {
          props: {},
          TipsContainerComponent: components_lib_1.RowFlexStart
        };
      }

      var swiperContainerWidth = medium ? 280 : 240;

      var swiperSlideWidth = _this.setSwiperSlideWidth();

      var props = {
        containerWidth: swiperContainerWidth,
        slideWrapperStyle: {
          width: swiperSlideWidth
        },
        controlsEnabled: true,
        controlsPressHandler: _this.swiperControlsPressHandler
      };
      return {
        props: props,
        TipsContainerComponent: components_lib_1.ContentWithSwiper
      };
    };

    _this.setSwiperSlideWidth = function () {
      var _a = _this.props,
          activeBreakpoint = _a.activeBreakpoint,
          width = _a.width;
      var small = responsive_1.isSmall(activeBreakpoint);
      var medium = responsive_1.isMedium(activeBreakpoint);
      var large = responsive_1.isLarge(activeBreakpoint);

      if (small) {
        return width < 460 ? width - 34 : 460;
      }

      if (large || medium) {
        return 460;
      }

      return 1000;
    };

    _this.shouldRenderAllTips = function () {
      return _this.props.numberOfTipsToRender === 'all';
    };

    _this.renderTipsItems = function () {
      var _a = _this.props,
          tips = _a.moduleData.tips,
          rectangleColor = _a.rectangleColor,
          activeBreakpoint = _a.activeBreakpoint,
          numberOfTipsToRender = _a.numberOfTipsToRender;
      var tipsToRender = 0;

      if (numberOfTipsToRender === 'all') {
        tipsToRender = tips.length;
      } else {
        tipsToRender = numberOfTipsToRender;
      }

      var randomPosition = function randomPosition() {
        return utilities_1.randomNumber(1, tipsToRender - 1);
      };

      var positions = [randomPosition(), randomPosition(), randomPosition(), randomPosition()];
      var position = positions.shift();
      return tips.slice(0, tipsToRender).map(function (tip, idx) {
        var shouldRenderMascot = false;

        if (responsive_1.isExtraLarge(activeBreakpoint) && idx === position) {
          var config = _this.mascotPositionsConfig[position] ? _this.mascotPositionsConfig[position] : _this.mascotPositionsConfig[1];
          var configPos = utilities_1.randomNumber(0, 1);
          shouldRenderMascot = true;
          return react_1.default.createElement(index_1.Rectangle, {
            key: idx,
            backgroundcolor: rectangleColor,
            degree: _this.tipsRotationAngles[randomTo3()],
            text: tip,
            shouldRenderMascot: shouldRenderMascot,
            mascotConfig: config[configPos]
          });
        }

        return react_1.default.createElement(index_1.Rectangle, {
          key: idx,
          backgroundcolor: rectangleColor,
          degree: _this.tipsRotationAngles[randomTo3()],
          text: tip,
          shouldRenderMascot: shouldRenderMascot
        });
      });
    };

    _this.visibilityChangeHandler = function (isVisible) {
      var _a = _this.props,
          sectionName = _a.sectionName,
          moduleName = _a.moduleName;
      var payload = {
        moduleId: moduleName,
        sectionId: _this.sectionNamesMap[sectionName]
      };

      if (isVisible) {
        _this.props.moduleSectionTipsAndTricksInView(payload);

        return;
      }

      _this.props.moduleSectionTipsAndTricksOutOfView(payload);
    };

    return _this;
  }

  ModuleSection.prototype.renderTitleWrapper = function () {
    var activeBreakpoint = this.props.activeBreakpoint;
    return react_1.default.createElement(index_1.TitleBold, {
      activeBreakpoint: activeBreakpoint
    }, this.props.user, ", people admire your four", '\n', "natural abilities");
  };

  ModuleSection.prototype.renderEmptyWrapper = function () {
    var activeBreakpoint = this.props.activeBreakpoint;
    return react_1.default.createElement(index_1.TitleBold, {
      activeBreakpoint: activeBreakpoint
    });
  };

  ModuleSection.prototype.renderPictureWrapper = function () {
    var _a = this.props,
        activeBreakpoint = _a.activeBreakpoint,
        image = _a.image,
        layoutType = _a.layoutType;
    var extraLarge = responsive_1.isExtraLarge(activeBreakpoint);
    var config = this.mascotConfigPositionSmallBreakpoint[randomTo3()];
    var mascotConfig = config ? config : this.mascotConfigPositionSmallBreakpoint[1];
    return react_1.default.createElement(WithRelativePos, null, react_1.default.createElement(index_1.FlaskContainer, {
      activeBreakpoint: activeBreakpoint,
      layoutType: layoutType
    }, react_1.default.createElement(components_lib_1.Row, null, react_1.default.createElement(index_1.ImageFlask, {
      source: {
        uri: image ? "data:image/png;base64," + image : ""
      }
    }))), !extraLarge && react_1.default.createElement(index_1.ImageOwlTips, {
      top: mascotConfig.top,
      bottom: mascotConfig.bottom,
      left: mascotConfig.left,
      rotate: mascotConfig.rotate
    }));
  };

  ModuleSection.prototype.renderRectangleWrapper = function () {
    var _a = this.props.moduleData,
        title = _a.title,
        description = _a.description;
    var _b = this.props,
        activeBreakpoint = _b.activeBreakpoint,
        withCustomAnalytics = _b.withCustomAnalytics; // todo tips default title and description!

    return react_1.default.createElement(index_1.ThreeFourth, {
      activeBreakpoint: activeBreakpoint
    }, react_1.default.createElement(TitleFixer, {
      ellipsizeMode: "tail",
      numberOfLines: 8
    }, react_1.default.createElement(content_parser_1.ParsedContent, {
      content: title ? title : '---'
    })), react_1.default.createElement(index_1.AbilityDescriptionComponent, {
      activeBreakpoint: activeBreakpoint
    }, react_1.default.createElement(content_parser_1.ParsedContent, {
      content: description ? description : '---'
    })), react_1.default.createElement(components_lib_1.Paragraph, {
      size: components_lib_1.ParagraphSizeEnum.big
    }, "Tips & Tricks"), withCustomAnalytics ? react_1.default.createElement(utilities_1.VisibilityTracker, {
      minTopValue: 240,
      scrollDelay: 600,
      intervalDelay: 1000,
      visibilityChangeHandler: this.visibilityChangeHandler
    }, react_1.default.createElement(index_1.RectangleWrapper, null, this.renderTips())) : react_1.default.createElement(index_1.RectangleWrapper, null, this.renderTips()));
  };

  ModuleSection.prototype.render = function () {
    var _a = this.props,
        layoutType = _a.layoutType,
        backgroundColor = _a.backgroundColor,
        activeBreakpoint = _a.activeBreakpoint,
        _b = _a.moduleData,
        header = _b.header,
        popUpTip = _b.popUpTip,
        onLayoutHandler = _a.onLayoutHandler,
        scrollToSectionHandler = _a.scrollToSectionHandler,
        viewOrderName = _a.viewOrderName;
    var isExtraLargeActive = responsive_1.isExtraLarge(activeBreakpoint);
    var shouldRenderImageFirst = layoutType === moduleSectionLayoutType_enum_1.ModuleSectionLayoutTypeEnum.image || !isExtraLargeActive;
    return react_1.default.createElement(index_1.SectionContainer, {
      backgroundColor: backgroundColor,
      onLayout: function onLayout(event) {
        var height = event.nativeEvent.layout.height;
        onLayoutHandler(viewOrderName, height);
      }
    }, react_1.default.createElement(index_1.ContentRowResponsive, null, react_1.default.createElement(index_1.ContentRow, null, react_1.default.createElement(components_lib_1.ColumnCenteredResponsive, {
      xl: 100
    }, react_1.default.createElement(index_1.LabelWrapper, null, react_1.default.createElement(Label, {
      ellipsizeMode: "tail",
      numberOfLines: 3
    }, react_1.default.createElement(content_parser_1.ParsedContent, {
      content: header
    }))), react_1.default.createElement(ContentContainer, null, shouldRenderImageFirst ? react_1.default.createElement(react_1.default.Fragment, null, this.renderPictureWrapper(), this.renderRectangleWrapper()) : react_1.default.createElement(react_1.default.Fragment, null, this.renderRectangleWrapper(), this.renderPictureWrapper()))))), react_1.default.createElement(index_1.ScrollDown, {
      scrollToSectionHandler: scrollToSectionHandler
    }), !!popUpTip && react_1.default.createElement(InteractiveImageRow, null, react_1.default.createElement(index_1.InteractiveImage, {
      infoText: this.interactiveImageInfoText,
      revealedText: popUpTip
    })));
  };

  return ModuleSection;
}(react_1.default.Component);

var ContentContainer = styled_components_1.default(index_1.ContentRowCentered)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var WithRelativePos = styled_components_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var Label = styled_components_1.default(index_1.ParagraphWithColor)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    align-self: flex-start;\n    margin-bottom: 8px;\n    font-size: 24px;\n    line-height: 1.2;\n    font-weight: bold;\n    font-family: Ubuntu;\n    color: ", ";\n"], ["\n    align-self: flex-start;\n    margin-bottom: 8px;\n    font-size: 24px;\n    line-height: 1.2;\n    font-weight: bold;\n    font-family: Ubuntu;\n    color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.title;
});
var TitleFixer = styled_components_1.default(components_lib_1.Title)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    max-width: 420px;\n"], ["\n    max-width: 420px;\n"])));
var InteractiveImageRow = styled_components_1.default(components_lib_1.RowCenteredResponsive)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    justify-content: flex-end;\n    margin-bottom: 20px;\n"], ["\n    justify-content: flex-end;\n    margin-bottom: 20px;\n"])));

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    moduleSectionTipsAndTricksInView: redux_1.bindActionCreators(store_1.moduleSectionTipsAndTricksInViewActionCreator, dispatch),
    moduleSectionTipsAndTricksOutOfView: redux_1.bindActionCreators(store_1.moduleSectionTipsAndTricksOutOfViewActionCreator, dispatch),
    tipsAndTricksInteraction: redux_1.bindActionCreators(store_1.tipsAndTricksInteractionActionCreator, dispatch)
  };
};

var connector = react_redux_1.connect(null, mapDispatchToProps);
var hoc = redux_1.compose(responsive_1.withResponsiveMeta, connector);
exports.default = hoc(ModuleSection);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;